import { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MediaDeviceMenuActions from '../../../../Modules/Redux/Components/MediaDeviceMenu/MediaDeviceMenuActions';
import MediaDeviceMenuSelector from '../../../../Modules/Redux/Components/MediaDeviceMenu/MediaDeviceMenuSelector';
import { Menu } from '../Menu/Menu';
import { MenuItem } from '../Menu/Models/MenuItem';
import { Switch } from '../Switch/Switch';
import { SwitchCase } from '../SwitchCase/SwitchCase';

export const MediaDeviceMenu: FunctionComponent = () => {
  const dispatch = useDispatch();
  const availableMediaInfos: MediaDeviceInfo[] = useSelector(MediaDeviceMenuSelector.availableMediaInfos);
  const state = useSelector(MediaDeviceMenuSelector.state);

  useEffect(() => {
    dispatch(MediaDeviceMenuActions.getAvailableMediaDevices());
  }, []);

  function menuItemForMediaDevice(mediaDevice: MediaDeviceInfo): MenuItem {
    return {
      id: mediaDevice.deviceId,
      item: mediaDevice.label
    };
  }

  function didSelectMediaDeviceWithId(mediaDeviceId: string): void {
    dispatch(MediaDeviceMenuActions.selectMediaDeviceWithId(mediaDeviceId));
  }

  return (
    <Switch value={state.current}>
      <SwitchCase value="data">
        <Menu
          items={availableMediaInfos.map(menuItemForMediaDevice)}
          defaultValue={'undefined'}
          disabledItem={'Select your capture card'}
          onChange={didSelectMediaDeviceWithId}
        />
      </SwitchCase>
      <SwitchCase value="error">
        <div className="w-full px-3 py-1 v-stack items-center text-center bg-bg-tertiary rounded-lg box-border">
          <p className="text-text-secondary leading-5">
            {
              'Camera permission required in order to access your capture card. Please go to your Chrome preferences > Privacy and security > smo-speedrun.herokuapp.com > Allow camera.'
            }
          </p>
        </div>
      </SwitchCase>
    </Switch>
  );
};
